$(function() {
    $('img').error(function () {
        $(this).hide();
    });

    $('.slick').slick() 

	$('.tabs').on('change.zf.tabs', function () {
		$('.slick').slick('setPosition');
	});
	
	$('#header a[href*=\\#]').on('click', function(e){     
		e.preventDefault();
		$('html,body').animate({scrollTop:$(this.hash).offset().top}, 500);
	})

	//app.scroll.init();
	//app.effects.init();
	app.map.init();
	app.ticker.init();
});

$(document).foundation();